import { render, staticRenderFns } from "./martship.vue?vue&type=template&id=edb6971a&scoped=true"
import script from "./martship.vue?vue&type=script&lang=js"
export * from "./martship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb6971a",
  null
  
)

export default component.exports